import React, { ReactNode } from 'react'
import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import { LoadStatus } from 'store/slices/dataAnalysisSlice'
import { prettyAttr } from '../utils/consts'
import * as sxStyles from './layout.styles'

export interface ITrendChartStatusProps {
  status: LoadStatus
  title: string
  children: ReactNode
}

export const TrendChartStatus: React.FC<ITrendChartStatusProps> = ({
  status,
  title,
  children,
}) => {
  if (status === 'loading') {
    return (
      <Box sx={sxStyles.trendChartLoadingBoxWrapper}>
        <CircularProgress size={80} thickness={4} />
      </Box>
    )
  }

  if (status === 'failed') {
    return (
      <Box sx={sxStyles.trendChartFailedBoxWrapper}>
        <Typography variant="h5" color="primary" fontWeight={600}>
          {title
            ? `Unable to display ${prettyAttr(title)} data`
            : `Unable to display trend chart data`}
        </Typography>
        <Typography variant="h6" color="text.secondary">
          Please refresh or try again later
        </Typography>
      </Box>
    )
  }

  return <Box sx={sxStyles.trendChartSuccessBoxWrapper}>{children}</Box>
}
